import cx from 'classnames'
import Icon from 'components/Icon'
import { FormGroupContainer, FormRow } from 'components/inputs'
import {
  CustomSelect,
  RenderSearchItemProps,
  useCustomSelectStateFromItemSource,
} from 'components/inputs/CustomSelect'
import SearchResultItem from 'components/inputs/CustomSelect/SearchResultItem'
import { observer } from 'mobx-react'
import React from 'react'
import styles from './TransferClientTeamDialog.sass'
import { truncate } from 'lodash'
import ClientTeamInputEditorViewModel from './ClientTeamInputEditorViewModel'
import TeamMember from 'iam/models/TeamMember'

interface ClientTeamInputEditorProps {
  vm: ClientTeamInputEditorViewModel
}

export default observer(function ClientTeamInputEditor({
  vm,
}: ClientTeamInputEditorProps) {
  const selectClientTeamProps = useCustomSelectStateFromItemSource({
    itemSource: vm.fetchClientTeamMembers,
    debounce: 250,
  })

  return (
    <>
      <FormRow className={styles.row}>
        <FormGroupContainer
          model={vm}
          field="clientTeamMember"
          className={styles.selectClientTeamContainer}
          error={vm.validationClientTeamMember.getError('clientTeamMember')}
        >
          <div className={styles.newClientTeamLabel}>New Client Team</div>
          <CustomSelect
            {...selectClientTeamProps}
            multi={false}
            icon={<Icon name="dropdown" className={cx(styles.icon)} />}
            itemToString={(i) => truncate(i.team.name, { length: 60 })}
            placeholder="Select new client team"
            value={vm.clientTeamMember}
            onChange={vm.setClientTeamMember}
            renderSearchItem={(props) => (
              <TransferToClientTeamSearchItem {...props} />
            )}
            data-test="transfer-to-client-team-dropdown"
          />
        </FormGroupContainer>
        <div className={styles.warning}>
          Make sure that the Client and/or Team you are transferring to has a
          valid billing method!
        </div>
      </FormRow>
    </>
  )
})

interface TransferToClientTeamSearchItem
  extends RenderSearchItemProps<TeamMember> {}

const TransferToClientTeamSearchItem = React.forwardRef(
  (
    { item, itemToString, ...itemProps }: TransferToClientTeamSearchItem,
    ref: React.Ref<any>
  ) => {
    return (
      <SearchResultItem
        className={cx(styles.searchResultItem)}
        ref={ref}
        {...itemProps}
        data-test={
          'transfer-to-client-team-option-' +
          (item?.team.id?.toLowerCase() || item?.team.name.toLowerCase())
        }
      >
        {item?.team.name}
      </SearchResultItem>
    )
  }
)
